/**
 * Maps dynamic-import / MIME failures (stale Vite chunks after deploy —
 * SPA fallback serves index.html) to a user-facing refresh prompt.
 */
export function pdfRenderErrorMessage(
  err: unknown,
  fallback = "Failed to render PDF",
): string {
  const message = err instanceof Error ? err.message : String(err ?? "");
  if (
    /Failed to fetch dynamically imported module|Loading chunk [\w.-]+ failed|MIME type of ["']?text\/html/i.test(
      message,
    )
  ) {
    return "App updated — refresh the page and try again.";
  }
  return message.trim() || fallback;
}
